import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';




import { LanguageService } from '../internal/language-service';
//import { Absence, Sighting } from '../../models/models';
//import { environment } from '@env/environment';
import { EventService } from '../internal/event-service';
import { Sighting } from '@spotter/models/sighting';
import { Absence } from '@spotter/models/absence';
import { TranslateService } from '@ngx-translate/core';
import { APP_VERSION } from '@spotterworkspace/version';
//import { AuthService } from './auth-service';


export interface MultipleChoiceQuestion
{
    q: string;
    a: string[];
}

interface TextboxQuestion
{
    q: string;
}

/** The questions asked in a Sighting */
interface SightingQuestions
{
    observe: MultipleChoiceQuestion;
    extensive: MultipleChoiceQuestion;
    length: MultipleChoiceQuestion; 
    percentage_cover: MultipleChoiceQuestion;
    flowers: MultipleChoiceQuestion; 
    algae: MultipleChoiceQuestion; 
    sediment: MultipleChoiceQuestion; 
    boats: MultipleChoiceQuestion;
    moorings: MultipleChoiceQuestion; 
    intertidal: MultipleChoiceQuestion; 
    fishing: MultipleChoiceQuestion; 
    fishing_gear: TextboxQuestion;
    fishing_caught: TextboxQuestion;
    damages: TextboxQuestion;
    depth: MultipleChoiceQuestion; 
    changes: TextboxQuestion;
    additional_species: TextboxQuestion;
    confidence: MultipleChoiceQuestion; 
    recreational_activity: TextboxQuestion;

    flowering_density: TextboxQuestion;
    fruiting_density: TextboxQuestion;
    number_of_seeds: TextboxQuestion;
    seed_length: TextboxQuestion;
    water_temperature: TextboxQuestion;
    water_temperature_measurement: TextboxQuestion;
}

/** The questions asked in an Absence */
interface AbsenceQuestions
{
    status: MultipleChoiceQuestion;
    sediment: MultipleChoiceQuestion;
    habitat: MultipleChoiceQuestion;
    comments: TextboxQuestion;
}



@Injectable({ providedIn: 'root' })
export class QuestionsService {
	//env = environment;

    sightingQuestions!: SightingQuestions;
    absenceQuestions!: AbsenceQuestions;

	/** The constructor */
	constructor(public http: HttpClient, private lang: LanguageService)
	{

	}

    initialise(): Promise<boolean>
    {
        return new Promise<boolean>((resolve, reject) => {

            this.http.get<any>("/spotter-shared/assets/i18n/"+this.lang.language.code+".json?v=" + APP_VERSION)
            .subscribe({
                next: (data) => {
                    this.sightingQuestions = data.uploadq;
                    this.absenceQuestions = data.uploadq_a;

                    if (this.lang.language.code =="en")
                    {
                        resolve(true);
                    }
                    else
                    {
                          // Load the English version to fill in any missing fields
                        this.http.get<any>("/spotter-shared/assets/i18n/en.json?v=" + APP_VERSION)
                        .subscribe({
                            next: (englishVersion) => {
                                this.copyMissingFields(englishVersion.uploadq_a, this.absenceQuestions);
                                this.copyMissingFields(englishVersion.uploadq, this.sightingQuestions);
                                resolve(true);
                            },
                            error: (error) => {
                                console.error("Unable to load the English questions");
                                reject(error);
                            }
                        }); 
                    }
              
                  
                },
                error: (error) => {
                    console.error(`Unable to load the ${this.lang.language.name} questions`);
                    reject(error);
                }
            });

        });    
    }


    /** Copies the missing fields from A to B */
    copyMissingFields(objA: any, objB: any): void {
        for (const key in objA)
        {
            if (objA.hasOwnProperty(key) && objB.hasOwnProperty(key))
            {
                if (typeof objA[key] === 'object' && typeof objB[key] === 'object')
                    this.copyMissingFields(objA[key], objB[key]);
                else if (objB[key] === null || objB[key] === undefined || objB[key] === '')
                    objB[key] = objA[key];
            }
        }
    }


}
